var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getToken } from '@/utils';
import { baseGetApi, rootApi, rootApiPost } from '@/utils/rest';
export var queueObjects = {
    get: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApi('/api/queueobjects/')];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
};
export var ticketReport = {
    get: function (filterParams) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPost('/api/reports/build', {
                        filters: {
                            main: filterParams,
                        },
                        token: getToken(),
                        type: 'ticketReport',
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.answer];
            }
        });
    }); },
    exportReport: function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var filterParams, columns;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filterParams = params.filterParams, columns = params.columns;
                    return [4 /*yield*/, rootApiPost('/api/reports/newexport', {
                            filters: {
                                main: __assign({}, filterParams),
                            },
                            columns: columns,
                            token: getToken(),
                            type: 'ticketReport',
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    banUser: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseGetApi('blacklist', 'add', {
                        payload: { data: __assign({}, data) },
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    unbanUser: function (ip) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseGetApi("blacklist/".concat(ip), 'delete', {
                        payload: { data: {} },
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    getBanned: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseGetApi('blacklist', 'get', {
                        payload: { data: {} },
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
};
export var serviceReport = {
    get: function (filterParams) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPost('/api/reports/build', {
                        filters: {
                            main: filterParams,
                        },
                        token: getToken(),
                        type: 'queueReport',
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.answer];
            }
        });
    }); },
    exportReport: function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var filterParams, columns;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filterParams = params.filterParams, columns = params.columns;
                    return [4 /*yield*/, rootApiPost('/api/reports/newexport', {
                            filters: {
                                main: __assign({}, filterParams),
                            },
                            columns: columns,
                            token: getToken(),
                            type: 'queueReport',
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
};
export var sourceReport = {
    get: function (filterParams) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPost('/api/reports/build', {
                        filters: {
                            main: filterParams,
                        },
                        token: getToken(),
                        type: 'sourceReport',
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.answer];
            }
        });
    }); },
    exportReport: function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var filterParams, columns;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filterParams = params.filterParams, columns = params.columns;
                    return [4 /*yield*/, rootApiPost('/api/reports/newexport', {
                            filters: {
                                main: __assign({}, filterParams),
                            },
                            columns: columns,
                            token: getToken(),
                            type: 'sourceReport',
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
};
export var surveyReport = {
    get: function (filterParams) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPost('/api/reports/build', {
                        filters: {
                            main: filterParams,
                        },
                        token: getToken(),
                        type: 'dictionaryReport',
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.answer];
            }
        });
    }); },
    exportReport: function (filterParams) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPost('/api/reports/build', {
                        filters: {
                            main: __assign({}, filterParams),
                        },
                        exports: 'true',
                        token: getToken(),
                        type: 'dictionaryReport',
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    getAnswers: function (filterParams) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPost('/api/reports/build', {
                        filters: {
                            main: filterParams,
                        },
                        token: getToken(),
                        type: 'dictionaryAnswersReport',
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.answer];
            }
        });
    }); },
};
export var operatorReport = {
    get: function (filterParams) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPost('/api/reports/build', {
                        filters: {
                            main: filterParams,
                        },
                        token: getToken(),
                        type: 'operatorReport',
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.answer];
            }
        });
    }); },
    exportReport: function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var filterParams, columns;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filterParams = params.filterParams, columns = params.columns;
                    return [4 /*yield*/, rootApiPost('/api/reports/newexport', {
                            filters: {
                                main: __assign({}, filterParams),
                            },
                            columns: columns,
                            token: getToken(),
                            type: 'operatorReport',
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
};
export var hourlyReport = {
    get: function (filterParams) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPost('/api/reports/build', {
                        filters: {
                            main: filterParams,
                        },
                        token: getToken(),
                        type: 'clockwiseReport',
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.answer];
            }
        });
    }); },
};
export var consolidatedReport = {
    get: function (sql) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseGetApi('genreportfromquery', 'get', {
                        payload: { data: { querySql: sql } },
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
};
export var wplacesReport = {
    get: function (filterParams) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPost('/api/reports/build', {
                        filters: {
                            main: filterParams,
                        },
                        token: getToken(),
                        type: 'workPlaceQuery',
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.answer];
            }
        });
    }); },
    exportReport: function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var filterParams, columns;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filterParams = params.filterParams, columns = params.columns;
                    return [4 /*yield*/, rootApiPost('/api/reports/newexport', {
                            filters: {
                                main: __assign({}, filterParams),
                            },
                            columns: columns,
                            token: getToken(),
                            type: 'workPlaceQuery',
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
};
